---
title: What to Log in Roddo
description: What matters most in a fishing log — and what you can ignore to stay consistent.
---

# What to Log in Roddo

The best fishing log is the one you’ll actually keep.

Roddo works best when you capture **a few consistent signals**, not everything.

## Log these (high value)
- **Time window** (morning, mid-day, evening)
- **Water type** (pond, lake, river, shore)
- **General location** (not precise if you don’t want to)
- **Bait/lure + presentation** (slow, fast, bottom, suspended)
- **Depth clue** (shallow, mid, deep — rough is fine)
- **Result** (caught / missed / nothing)
- **One sentence:** what felt different?

## Optional (only if easy)
- wind direction
- pressure trend (rising/falling)
- water clarity
- tide stage (saltwater)
- moon/solunar (as context, not truth)

## Skip these (low value early)
- over-precise guesses
- too many tags
- rewriting the entire trip
- trying to “measure” everything

Consistency beats detail.

### Keep learning
- [Logging a catch in under 60 seconds](/learn/app/logging-under-60-seconds)
- [Review your logs for patterns](/learn/app/reviewing-logs)
- [Roddo Learn hub](/learn)
